import userConstants from 'core/constants/userConstants'
import jwt from 'jsonwebtoken'
import FilterStorage from '../filterSotarage/filterStorage'

const getAccount = () => {
  const userData = Auth.getUserData()
  if (userData) {
    const { nombreCompleto } = userData

    return {
      userName: nombreCompleto,
      ...userData
    }
  }
  return null
}

const getUserToken = ()=> {
  const data = Auth.getUserData();
  if(data)
    return data.userToken;
  return null;
};

const getUserOcaToken = ()=> {
  const data = Auth.getUserData();
  const jwtInfo = data && jwt.decode(data.userToken)
  if(jwtInfo){
    return jwtInfo.tokenName;
  }
  return null;
};

const Auth = {
  isAuthenticated() {
    return getUserToken() !== null
  },
  getToken: ()=> {
    return getUserToken()
  },
  getOcaToken: () => {
    return getUserOcaToken()
  },
  getUserData: () => {
    const userData = localStorage.getItem(userConstants.USER_TOKEN)
    let jsonUserData
    if (userData) {
      try {
        jsonUserData = JSON.parse(userData)
      } catch (error) {
        return null
      }
      return jsonUserData?.data
    }
    return null
  }, 
  setUserToken: userToken => {
    localStorage.setItem(userConstants.USER_TOKEN, JSON.stringify(userToken))
  },
  getUserInfo: () => {
    const userAccount = getAccount()
    if (userAccount) {
      return userAccount
    }
    return null
  },
  removeUserInfo: () => {
    localStorage.removeItem(userConstants.USER_ACCOUNT)
    localStorage.removeItem(userConstants.USER_TOKEN)
    localStorage.removeItem(userConstants.FILTER_CONTABILIDAD)
    localStorage.removeItem(userConstants.SELECTED_CURRENT_MENU_ID)
    localStorage.removeItem(userConstants.USER_ACCOUNT_PROFILE_ID)
    FilterStorage.clearAllFilterData();
  },
  setUserInfo: userInfo => {
    localStorage.setItem(userConstants.USER_ACCOUNT, JSON.stringify(userInfo))
    FilterStorage.clearAllFilterData();
  },
  getUserName: ()=> {
    const account = localStorage.getItem(userConstants.USER_ACCOUNT)
    if(account) {
      const { userName } =  JSON.parse(account);
      return userName;
    }
    return null
  },
  setCurrentProfileId: (profileId)=> {
    localStorage.setItem(userConstants.USER_ACCOUNT_PROFILE_ID, profileId)
  },
  getCurrentProfileId: ()=> {
    return localStorage.getItem(userConstants.USER_ACCOUNT_PROFILE_ID)
  },
  setCurrentSelectMenuId: (idMenu)=> {
    localStorage.setItem(userConstants.SELECTED_CURRENT_MENU_ID, idMenu)
  },
  getCurrentSelectMenuId: ()=> {
    return localStorage.getItem(userConstants.SELECTED_CURRENT_MENU_ID)
  },
}

export default Auth
